import { useDialog } from "shared/dialog/use-dialog";
import { ShareListDialog } from "../favorite-list-components/share-list-dialog";
import { usePostApiAccountFavoritesByFavoriteListIdUserMutation } from "api/generatedApi";
import { useTranslation } from "react-i18next";
import { useToast } from "shared/toast/hooks/use-toast";
import { ResultDialogType, useMutation } from "utils/hooks/use-mutation";
import { SubmitHandler } from "react-hook-form";

interface Props {
  favoriteListId: string;
}

export const useShareList = (props: Props) => {
  const errorEmailNotFound = 404;
  const { t } = useTranslation();
  const toast = useToast();

  const [openShareListDialog, closeShareListDialog] = useDialog(ShareListDialog);
  const [shareList] = usePostApiAccountFavoritesByFavoriteListIdUserMutation();

  const handleSuccess = () => {
    closeShareListDialog();
  };

  const wrapMutation = useMutation({
    onSuccess: handleSuccess,
    successProps: {
      description: t("account.favorites.createListToastSuccess"),
    },

    onError: (error) => {
      toast.error(error?.status === errorEmailNotFound ? t("account.favorites.noEmailFound") : t("account.favorites.standardShareError"));
    },

    resultDialogType: ResultDialogType.Toast,
  });

  const handleOnSubmit: SubmitHandler<{ email: string }> = (data) => {
    wrapMutation(
      shareList({
        favoriteListId: props.favoriteListId,
        addAffiliateToPersonalFavoriteListRequest: {
          email: data.email,
        },
      })
    );
  };

  const handleClick = () => {
    openShareListDialog({ onSubmit: handleOnSubmit });
  };

  return handleClick;
};
